import {
  Affix,
  Button,
  Form,
  Input,
  message,
  Row,
  Space,
  Spin,
  Switch,
  Typography
} from 'antd';
import React, { useEffect, useState } from 'react';
import Compress from 'react-image-file-resizer';
import BoxImage from '../../../../components/BoxImage';
import ResponsiveContainer from '../../../../components/ResponsiveContainer';
import { useInspeccionContext } from '../../../../context/inspeccion-context';
import Camara from '../../../../static/autos/Camara.jpg';
import { errorHandler, heicAndheifConvert } from '../../../../utils';
import { cardsGeneral } from '../../CarUtil';
import TarjetaEdit from './TarjetaEdit';

const { Title } = Typography;

function FotografiasGrid({ title, ...props }) {
  const { inspeccion, getImages, updateInspeccion } = useInspeccionContext();
  const [loading, setLoading] = useState(false);
  const [imagenes, setImagenes] = useState([]);
  const [showComentario, setShowComentario] = useState(false);
  const [comentario, setComentario] = useState('');
  const [finalizarDisable, setFinalizarDisable] = useState(true);
  const [cards, setCards] = useState(cardsGeneral);
  const [text, setText] = useState();
  const [newKey, setNewKey] = useState(-1);
  const [cantfotos, setCantfotos] = useState(0);
  const [extraFoto, setExtraFoto] = useState(false);
  const [check, setCheck] = useState(true);

  const { uploadFile } = useInspeccionContext();
  useEffect(() => {
    getImagenes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const countFotos = async () => {
    let cont = 0;
    const imagenesNews = await getImages(inspeccion);
    imagenesNews.forEach((element) => {
      if (element.paso_nro > 0) {
        cont += 1;
      }
    });
    setCantfotos(cont);
    if (cont === 12) {
      setFinalizarDisable(false);
    }
  };

  const getImagenes = async () => {
    setLoading(true);
    const newCards = cardsGeneral;
    const imagenesNews = await getImages(inspeccion);
    setImagenes(imagenesNews);
    let cont = 0;
    const keys = [];
    imagenesNews.forEach((element) => {
      keys.push(element.paso_nro);
      if (element.paso_nro > 0) {
        cont += 1;
      } else {
        let flag = true;
        cards.forEach((element2) => {
          if (element2.key === element.paso_nro) {
            flag = false;
          }
        });
        if (flag) {
          newCards.push({
            item: `${element.paso_nro}`,
            key: element.paso_nro,
            parte: element.parte,
            image: Camara,
            check: false
          });
        }
      }
    });
    const min = Math.min(...keys) - 1;
    setNewKey(min);
    setCards(newCards);
    setCantfotos(cont);
    if (cont === 12) {
      setFinalizarDisable(false);
    }
    setLoading(false);
  };

  const updateStatus = async () => {
    const result = await updateInspeccion('FOTOS_SUBIDAS', comentario);
    return result;
  };

  const goTo = async () => {
    props.continueStep();
  };

  const finalizar = async () => {
    try {
      await updateStatus();
      props.next();
    } catch (err) {
      errorHandler(err);
    }
  };

  const onChange = async (value) => {
    setShowComentario(value);
  };

  const handleInputChange = async (field, value) => {
    setComentario(value.target.value);
  };

  const savename = async (newtext) => {
    if (newtext.trim() === '') {
      setCheck(true);
      message.info('Debe asignar nombre a la imagen');
    } else {
      setText(newtext);
      setCheck(false);
    }
  };

  const saveimage = async (file) => {
    try {
      setLoading(true);
      await uploadFile(file, newKey, inspeccion, text);
      getImagenes();
      setExtraFoto(false);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      // error
    }
  };

  const customRequest = async ({ file }) => {
    const converted = await heicAndheifConvert(file);
    try {
      Compress.imageFileResizer(
        converted, // the file from input
        2400, // width
        1600, // height
        'JPEG', // compress format WEBP, JPEG, PNG
        90, // quality
        0, // rotation
        (uri) => {
          saveimage(uri);
        },
        'blob' // blob or base64 default base64
      );
    } catch (error) {
      message.error(error);
    }
  };

  const getExtraFoto = () => {
    if (extraFoto) {
      const card = [
        {
          item: `${newKey}`,
          key: newKey,
          parte: text,
          image: Camara,
          check: false
        }
      ];
      return (
        <>
          <Form.Item>
            {' '}
            <Input
              autoSize={{ minRows: 1, maxRows: 6 }}
              placeholder="Parte del vehículo"
              onBlur={(e) => {
                savename(e.target.value);
              }}
              autoFocus
            />
          </Form.Item>
          <BoxImage
            customRequest={customRequest}
            imagen={Camara}
            loading={loading}
            card={card}
            disabled={check}
          />
        </>
      );
    }
    return <p />;
  };

  const getComentario = () => {
    if (showComentario) {
      return (
        <Form.Item
          label="Comentario"
          onChange={(e) => {
            handleInputChange('Nombre', e);
          }}
        >
          {' '}
          <Input.TextArea autoSize={{ minRows: 1, maxRows: 6 }} />
        </Form.Item>
      );
    }
    return <p />;
  };

  const getRendered = () => {
    if (loading) {
      return (
        <Spin
          spinning={loading}
          delay={500}
          tip="Cargando Fotos..."
          style={{ paddingTop: 24 }}
        >
          <div className="content" />
        </Spin>
      );
    }
    return (
      <>
        <ResponsiveContainer size="large">
          <div style={{ textAlign: 'left' }}>
            <div style={{ paddingTop: 20 }}>
              <Title level={3} align="center">
                {title}
              </Title>
            </div>
            <>
              <Row gutter={[32, 16]}>
                {cards.map((card) => (
                  <TarjetaEdit
                    card={card}
                    key={card.parte}
                    imagenes={imagenes}
                    inspeccion={inspeccion}
                    count={countFotos}
                  />
                ))}
              </Row>
              <br />
              <Form>
                <Form.Item label="¿Desea agregar un comentario?">
                  <Switch
                    onChange={(value) => {
                      onChange(value);
                    }}
                  />
                </Form.Item>
                {getComentario()}
                <Form.Item label="¿Desea subir otra foto?">
                  <Switch
                    onChange={(value) => {
                      setExtraFoto(value);
                    }}
                  />
                </Form.Item>
                {getExtraFoto()}
              </Form>
            </>
          </div>
          <Space>
            <Button onClick={props.back}>Anterior</Button>
            <Button
              disabled={finalizarDisable}
              onClick={() => finalizar()}
              type="primary"
            >
              Finalizar
            </Button>
          </Space>
        </ResponsiveContainer>
        {cantfotos < 12 && (
          <Affix offsetBottom={20} style={{ position: 'fixed', left: 20 }}>
            <Button type="primary" onClick={() => goTo()}>
              Continuar
            </Button>
          </Affix>
        )}
      </>
    );
  };

  return getRendered();
}

export default FotografiasGrid;
